import React from 'react';

interface PhaseBackgroundProps {
  children: React.ReactNode;
  variant?: 'blue' | 'green' | 'red' | 'purple' | 'slate';
}

const backgroundClasses = {
  blue: 'bg-slate-50',
  green: 'bg-slate-50',
  red: 'bg-slate-50',
  purple: 'bg-slate-50',
  slate: 'bg-slate-50',
};

export const PhaseBackground: React.FC<PhaseBackgroundProps> = ({
  children,
  variant = 'blue',
}) => {
  return (
    <div className={`min-h-screen ${backgroundClasses[variant]}`}>
      {children}
    </div>
  );
};
